import { useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import Divider from '@mui/material/Divider'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import { canAccessRouter } from './../util/Functions'
import * as SG from '../style/Styles'
import * as S from '../style/Menu'
import * as TXT from './../util/Texts'
import { LogOut } from './../util/Functions'
import * as U from './../util/UrlHttp'

const styleFont = {}

export default function Menu() {

    const navigate = useNavigate()

    const [active, setActive]       = useState<any>({home:true, rank:false, myBest:false, myProfile:false, results:false, users:false, regulation:false, languages:false, groups:false})
    const [openClose, setOpenClose] = useState<boolean>(false)
    const [block, setBlock]         = useState<string>('')
    const [iconM, setIconM]         = useState<string>('fa-bars')

    const handleMenu = (url:string) => {
 
        if(url === 'login') 
            LogOut()
      
        navigate(`/${url}`)
    }

    const activeMenu = () => {

        const menuActive = window.location.pathname.split('/')
        setActive({home:false, rank:false, myBest:false, myProfile:false, results:false, users:false, regulation:false, languages:false, groups:false})

        switch (menuActive[1]) {
            case 'ranking':
                setActive({rank:true})
                break;
            case 'my-bets':
                setActive({myBest:true})
                break;
            case 'my-profile':
                setActive({myProfile:true})
                break;
            case 'groups':
            case 'groups-form':
                setActive({groups:true})
                break;
            case 'result':
                setActive({results:true})
                break;
            case 'users':
            case 'users-form':
                setActive({users:true})
                break;
            case 'languages':
            case 'languages-form':
                setActive({languages:true})
                break;
            case 'regulation':
                setActive({regulation:true})
                break;
            default:
                setActive({home:true})
                break;
        }
    }

    const openCloseMenu = () => {

        if (openClose){
            setBlock('')
            setIconM('fa-bars')
            setOpenClose(false)
        } else {
            setBlock('disB')
            setIconM('fa-xmark')
            setOpenClose(true)
        }

    }

    useEffect(()=>{
        activeMenu()
    }, [])

    return (
        <S.Menu className='menuContainer'>

            <SG.Span className='iconMenu' onClick={openCloseMenu}><SG.I className={`fa-solid ${iconM}`}></SG.I></SG.Span>
            <SG.LogoCopa className="iconLogoCopaMenu" src={U.LOGO_COPA} alt="Copa"  onClick={()=>{handleMenu('dashboard')}} />

            <MenuList className={`ListMenu ${block}`}>

                <MenuItem className={active.home ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('dashboard')}}>
                    <ListItemText className='txtMenu' style={styleFont}>{TXT.HOME}</ListItemText>
                </MenuItem>

                <Divider style={S.styleDivisor} />

                <MenuItem className={active.rank ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('ranking')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.RANKING}</ListItemText>
                </MenuItem>

                <Divider style={S.styleDivisor} />

                <MenuItem className={active.myBest ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('my-bets')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.MY_BETS}</ListItemText>
                </MenuItem>

                <Divider style={S.styleDivisor} />

                <MenuItem className={active.groups ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('groups')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.GROUPS}</ListItemText>
                </MenuItem>

                <Divider style={S.styleDivisor} />

                <MenuItem className={active.regulation ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('regulation')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.REGULAMENT}</ListItemText>
                </MenuItem>

                <Divider style={S.styleDivisor} />

                <MenuItem className={active.myProfile ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('my-profile')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.MY_PROFILE}</ListItemText>
                </MenuItem>

                {canAccessRouter('users') && 
                    <Divider style={S.styleDivisor} />
                }
                
                {canAccessRouter('users') && 
                <MenuItem className={active.users ? 'activeMenu menu' : 'menu'} onClick={()=>{handleMenu('users')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.USERS}</ListItemText>
                </MenuItem> 
                }

                {canAccessRouter('result') && 
                    <Divider style={S.styleDivisor} />
                }

                {canAccessRouter('result') &&
                <MenuItem className={active.results ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('result')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.RESULTS}</ListItemText>
                </MenuItem>
                }

                {canAccessRouter('languages') && 
                    <Divider style={S.styleDivisor} />
                }

                {canAccessRouter('languages') &&
                <MenuItem className={active.languages ? 'activeMenu menu' : ' menu'} onClick={()=>{handleMenu('languages')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.TRANSLATIONS}</ListItemText>
                </MenuItem>
                }

                <Divider style={S.styleDivisor} />

                <MenuItem onClick={()=>{handleMenu('login')}}>
                    <ListItemText className='txtMenu upperCase' style={styleFont}>{TXT.OUT}</ListItemText>
                </MenuItem>

            </MenuList>
          
        </S.Menu>
    );
}
  

